import { createBaseAction } from '@essent/common';
import type { InnogyComponentRendering } from '@core/jss-models';

export const enum RetentionOrderTypes {
  TRACK_PRODUCT_DETAIL = '[Retention] Track product detail',
}

export const trackProductDetail = createBaseAction<InnogyComponentRendering>(
  RetentionOrderTypes.TRACK_PRODUCT_DETAIL
);
